import React from 'react';
import { Navigate, useParams } from 'react-router-dom';
import type { PageHeaderTabs } from '@/components/ui/page-header';
import StrategyPage from '../StrategyPage';
import HorizonPage from '../HorizonPage';

/**
 * Drivers (web app v4 plan §5.1): your strategic drivers, and the year ahead
 * at /drivers/horizon (was "Outlook"). Both come with strategic drivers on
 * the plan (lib/planGates guards /drivers and everything under it). The view
 * draws the one page header, with these tabs in it.
 */
export default function DriversPage() {
  const { view } = useParams<{ view?: string }>();
  const horizon = view === 'horizon';
  if (view && !horizon) return <Navigate to="/drivers" replace />;
  const tabs: PageHeaderTabs = {
    label: 'Drivers views',
    panelId: 'drivers-panel',
    items: [
      { id: 'drivers', label: 'Drivers', to: '/drivers', selected: !horizon },
      { id: 'horizon', label: 'Horizon', to: '/drivers/horizon', selected: horizon },
    ],
  };
  return horizon ? <HorizonPage tabs={tabs} /> : <StrategyPage tabs={tabs} />;
}
